export const FETCH_QUESTION = "fetchQuestions";
export const SELECT_ANSWER = "selectAnswer";

export const FETCH_SETTINGS = "fetchSettings";
export const CREATE_QUOTE_INSTANCE = "createQuoteInstance";

export const SELECT_NEXT_QUESTION = "selectNextQuestion";
export const SELECT_PREV_QUESTION = "selectPrevQuestion";
export const RESTART_QUESTIONS = "restartQuestions";

export const SELECT_PRODUCT_PACK = "selectProductPack";

export const SUBMIT_QUESTIONS = "submitQuestions";


export const UPDATE_FINANCE_PERIOD = "updateFinancePeriod";

export const UPDATE_CUSTOMER_DETAILS = "updateCustomerdetails";


export const SAVE_CUSTOMER_DETAILS = "saveCustomerDetails";
export const SEARCH_POSTCODE = "searchPostcode";
export const SELECT_ADDRESS = "selectAddress";


export const QUESTIONS_COMPLETE = "questionsComplete";
export const CUSTOMER_DETAILS_COMPLETE = "customerDetailsComplete";

// Fired when the quote is complete.
export const COMPLETED_QUOTE = "completeQuote";

export const RESET_QUOTE = "resetQuote";